import api from "./api-service";

const controller = "dashboard";

export const getTherapistDashboardData = () =>
  api().get(controller + "/therapist");

export const getPatientDashboardData = () => api().get(controller + "/patient");
